export const DocumentReceiveOptionKind = {
  ORIGINAL_DOCUMENTS_RECEIVE_OPTION: "ORIG",
};

export const DocumentReceiveOption = {
  NO_SUBMISSION_REQUIRED: "NOOR",
};
